import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { ErrorToaster } from "../../components/toaster/Toaster";
import InputField from "../../components/Input";
import { Calendar } from "feather-icons-react/build/IconComponents";
import { DatePicker } from "antd";
import { DateFormate, noDoubleQuotes } from "../../../utils";
import dayjs from "dayjs";
import SelectField from "../../components/Select";
import { invoiceTypes } from "../../../core/json/invoiceTypes";
import { registrationTypes } from "../../../core/json/registrationTypes";
import InvoiceServices from "../../../services/Invoice";
import { v4 as uuidv4 } from 'uuid';
import { Alert } from "@mui/material";
import { useSelector } from "react-redux";
import { all_routes } from "../../../Router/all_routes";

export const Form = ({ onSubmit, loading, error }) => {

  const routes = all_routes;
  const navigate = useNavigate();
  const { id } = useParams();

  const { userData } = useSelector((state) => {
    return {
      userData: state.user_detail
    }
  });

  const [pageLoading, setPageLoading] = useState(false);

  const { register, handleSubmit, formState: { errors }, control, setValue } = useForm();
  const { register: register2, handleSubmit: handleSubmit2, formState: { errors: errors2 }, reset: reset2, setValue: setValue2 } = useForm();

  const [products, setProducts] = useState([]);
  const [updateProduct, setUpdateProduct] = useState(null);

  const [selectedInvoiceType, setSelectedInvoiceType] = useState(null);
  const [selectedRegistrationType, setSelectedRegistrationType] = useState(null);

  const [isInvoiceSubmitted, setIsInvoiceSubmitted] = useState(false);

  // *For Create/Update Invoice
  const submitForm = async (formData) => {
    try {
      if (products.length === 0) {
        ErrorToaster('Please add at least one product')
        return
      }

      const payload = {
        invoice_type: selectedInvoiceType?.id,
        invoice_date: dayjs(formData?.invoiceDate).format('YYYY-MM-DD'),
        invoice_ref_no: formData.invoiceRefNo,
        seller_ntn_cnic: formData.sellerNtnCnic,
        seller_strn: formData.sellerStrn,
        seller_business_name: formData.sellerBusinessName,
        seller_province: formData.sellerProvince,
        seller_address: formData.sellerAddress,
        buyer_ntn_cnic: formData.buyerNtnCnic,
        buyer_strn: formData.buyerStrn,
        buyer_business_name: formData.buyerBusinessName,
        buyer_province: formData.buyerProvince,
        buyer_address: formData.buyerAddress,
        buyer_registration_type: selectedRegistrationType?.id,
        reason: formData.reason,
        invoice_items: products?.map(item => {
          if (item?.invoice_id) {
            return item;
          } else {
            const { id, ...rest } = item;
            return rest;
          }
        })
      }
      if (userData?.environment === 'SANDBOX') {
        payload.scenario_id = formData?.scenarioId.toUpperCase()
      }
      onSubmit(payload)
    } catch (error) {
      console.log('🚀 => submitForm => error:', error)
    }
  };

  // *For Get Invoice Details
  const getInvoiceDetails = async () => {
    setPageLoading(true)
    try {
      const { data } = await InvoiceServices.getInvoiceById(id)
      setIsInvoiceSubmitted(data?.fbr_invoice_number ? true : false)
      setValue('invoiceType', data?.invoice_type)
      setSelectedInvoiceType({ id: data?.invoice_type, name: data?.invoice_type })
      setValue('invoiceDate', dayjs(data?.invoice_date))
      setValue('invoiceRefNo', data?.invoice_ref_no)
      setValue('sellerNtnCnic', data?.seller_ntn_cnic)
      setValue('sellerStrn', data?.seller_strn)
      setValue('sellerBusinessName', data?.seller_business_name)
      setValue('sellerProvince', data?.seller_province)
      setValue('sellerAddress', data?.seller_address)
      setValue('buyerNtnCnic', data?.buyer_ntn_cnic)
      setValue('buyerStrn', data?.buyer_strn)
      setValue('buyerBusinessName', data?.buyer_business_name)
      setValue('buyerProvince', data?.buyer_province)
      setValue('buyerAddress', data?.buyer_address)
      setValue('reason', data?.reason)
      setValue('registrationType', data?.buyer_registration_type)
      setSelectedRegistrationType({ id: data?.buyer_registration_type, name: data?.buyer_registration_type })
      setValue('scenarioId', data?.scenario_id)
      setProducts(data?.invoice_items)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setPageLoading(false)
    }
  }

  // *For Submit Invoice Row
  const submitInvoiceRow = async (formData) => {
    try {
      let obj = {
        hs_code: formData?.hsCode.trim(),
        product_description: formData?.productDescription,
        rate: formData?.saleTax,
        unit_of_measurement: formData?.unitOfMeasurement,
        quantity: formData?.quantity,
        total_values: formData?.totalValues,
        value_sales_excluding_st: formData?.valueSalesExcludingSt,
        fixed_notified_value_or_retail_price: formData?.fixedNotifiedValueOrRetailPrice || 0.00,
        sales_tax_applicable: formData?.salesTaxApplicable,
        sales_tax_with_held_at_source: formData?.salesTaxWithHeldAtSource || 0.00,
        extra_tax: formData?.extraTax || null,
        further_tax: formData?.furtherTax || 0.00,
        sro_schedule_no: formData?.sroScheduleNo,
        fed_payable: formData?.fedPayable || 0.00,
        discount: formData?.discount || 0.00,
        sale_type: formData?.saleType,
        sro_item_serial_no: formData?.sroItemSerialNo
      }
      if (updateProduct?.id) {
        const index = products.findIndex((e) => e.id === updateProduct?.id)

        if (index !== -1) {
          const updatedProductRows = [...products];
          updatedProductRows[index] = { ...updatedProductRows[index], ...obj };
          setProducts(updatedProductRows);
        }

      } else {
        const updateProductRow = [...products]
        updateProductRow.push({ id: uuidv4(), ...obj })
        setProducts(updateProductRow)
      }
      resetAddRowFields()
      const btn = document.getElementById('modalClose')
      btn.click();
    } catch (error) {
      console.log('submitForm => error:', error)
    }
  }

  // *For Delete Row
  const deleteInvoiceRow = (id) => {
    try {
      const index = products.findIndex((e) => e.id === id)
      const updateProductRow = [...products]
      updateProductRow.splice(index, 1);
      setProducts(updateProductRow)
    } catch (error) {
      console.log('deleteRow => error:', error)
    }
  }

  // *For Handle Reset Add Row Fields
  const resetAddRowFields = () => {
    try {
      reset2()
      setUpdateProduct()
    } catch (error) {
      console.log(' resetAddRowFields => error:', error)
    }
  }

  // *For Table Headers
  const renderTableHeader = () => {
    const baseHeaders = [
      'S.No',
      'Description',
      'Hs Code',
      'Qty',
      'UOM',
      'Retail Price',
      'Value (Excl. Tax)',
      'Tax %',
      'Sales Tax',
      'Tax Withheld',
      'Extra Tax',
      'Further Tax',
      'FED',
      'Discount',
      'Total (Incl. Tax)',
      'SRO No',
      'Sale Type',
      'SRO Serial',
    ];

    return (
      <tr>
        {baseHeaders.map((item, i) => (
          <th key={i}>{item}</th>
        ))}
        {!isInvoiceSubmitted &&
          <th>Actions</th>
        }
      </tr>
    );
  };

  // *For Table Body
  const renderTableBody = () => {
    return products?.map((item, index) => {
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item?.product_description || "-"}</td>
          <td>{item?.hs_code || "-"}</td>
          <td>{item?.quantity || "-"}</td>
          <td>{item?.unit_of_measurement || "-"}</td>
          <td>{item?.fixed_notified_value_or_retail_price || "-"}</td>
          <td>{item?.value_sales_excluding_st || "-"}</td>
          <td>{item?.rate}</td>
          <td>{item?.sales_tax_applicable || "-"}</td>
          <td>{item?.sales_tax_with_held_at_source || "-"}</td>
          <td>{item?.extra_tax || "-"}</td>
          <td>{item?.further_tax || "-"}</td>
          <td>{item?.fed_payable || "-"}</td>
          <td>{item?.discount || "-"}</td>
          <td>{item?.total_values || "-"}</td>
          <td>{item?.sro_schedule_no || "-"}</td>
          <td>{item?.sale_type || "-"}</td>
          <td>{item?.sro_item_serial_no || "-"}</td>
          {!isInvoiceSubmitted &&
            <td>
              <div className="action-table-data">
                <div className="edit-delete-action">
                  <button type="button" className="btn btn-sm btn-info btn-wave waves-effect waves-light me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#open-product-modal"
                    onClick={() => setUpdateProduct(item)}
                  >
                    Edit
                  </button>
                  <button type="button" className="btn btn-sm btn-danger btn-wave waves-effect waves-light me-2"
                    onClick={() => deleteInvoiceRow(item?.id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </td>
          }
        </tr>
      );
    });
  };

  useEffect(() => {
    if (id) {
      getInvoiceDetails()
    } else {
      setValue('invoiceType', invoiceTypes[0]?.id)
      setSelectedInvoiceType(invoiceTypes[0])
      setValue('invoiceDate', dayjs())
      setValue('sellerNtnCnic', userData?.ntn_cnic)
      setValue('sellerStrn', userData?.strn)
      setValue('sellerBusinessName', userData?.name)
      setValue('sellerAddress', userData?.address)
      setValue('sellerProvince', userData?.province)
    }
  }, [id]);

  useEffect(() => {
    if (updateProduct) {
      setValue2('hsCode', updateProduct?.hs_code)
      setValue2('productDescription', updateProduct?.product_description)
      setValue2('saleTax', updateProduct?.rate)
      setValue2('unitOfMeasurement', updateProduct?.unit_of_measurement)
      setValue2('quantity', updateProduct?.quantity)
      setValue2('totalValues', updateProduct?.total_values)
      setValue2('valueSalesExcludingSt', updateProduct?.value_sales_excluding_st)
      setValue2('fixedNotifiedValueOrRetailPrice', updateProduct?.fixed_notified_value_or_retail_price)
      setValue2('salesTaxApplicable', updateProduct?.sales_tax_applicable)
      setValue2('salesTaxWithHeldAtSource', updateProduct?.sales_tax_with_held_at_source)
      setValue2('extraTax', updateProduct?.extra_tax)
      setValue2('furtherTax', updateProduct?.further_tax)
      setValue2('sroScheduleNo', updateProduct?.sro_schedule_no)
      setValue2('fedPayable', updateProduct?.fed_payable)
      setValue2('discount', updateProduct?.discount)
      setValue2('saleType', updateProduct?.sale_type)
      setValue2('sroItemSerialNo', updateProduct?.sro_item_serial_no)
    }
  }, [updateProduct]);

  return (
    <>
      {/* ========== Add Product Modal ========== */}
      <div className="modal fade" id="open-product-modal">
        <div className="modal-dialog modal-dialog-centered custom-modal-two" style={{ maxWidth: '1200px' }}>
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{updateProduct?.id ? "Edit Product" : "Add Product"}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body new-employee-field">
                  <form onSubmit={handleSubmit2(submitInvoiceRow)}>
                    <div className="row">
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Description*"
                            error={errors2?.productDescription?.message}
                            register={register2("productDescription", {
                              required: 'Please enter product description.',
                              ...noDoubleQuotes()
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Hs Code*"
                            error={errors2?.hsCode?.message}
                            register={register2("hsCode", {
                              required: 'Please enter hs code.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Quantity*"
                            error={errors2?.quantity?.message}
                            register={register2("quantity", {
                              required: 'Please enter quantity.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Unit of Measurement*"
                            error={errors2?.unitOfMeasurement?.message}
                            register={register2("unitOfMeasurement", {
                              required: 'Please enter unit of measurement.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Retail Price"
                            register={register2("fixedNotifiedValueOrRetailPrice")}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Value (Excl. Tax)*"
                            error={errors2?.valueSalesExcludingSt?.message}
                            register={register2("valueSalesExcludingSt", {
                              required: 'Please enter Value (Excl. Tax).'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Tax (%)*"
                            error={errors2?.saleTax?.message}
                            register={register2("saleTax", {
                              required: 'Please enter tax %.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Sales Tax*"
                            error={errors2?.salesTaxApplicable?.message}
                            register={register2("salesTaxApplicable", {
                              required: 'Please enter sales tax applicable.'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Tax Withheld"
                            register={register2("salesTaxWithHeldAtSource")}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Extra Tax"
                            register={register2("extraTax")}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Further Tax"
                            register={register2("furtherTax")}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="FED Payable"
                            register={register2("fedPayable")}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Discount"
                            register={register2("discount")}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Total (Incl. Tax)*"
                            error={errors2?.totalValues?.message}
                            register={register2("totalValues", {
                              required: 'Please enter Total (Incl. Tax).'
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="SRO Schedule No"
                            register={register2("sroScheduleNo")}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="Sale Type*"
                            error={errors2?.saleType?.message}
                            register={register2("saleType", {
                              required: 'Please enter sale type.',
                              ...noDoubleQuotes()
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-3 col-6">
                        <div className="mb-3">
                          <InputField
                            label="SRO Serial No"
                            register={register2("sroItemSerialNo")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        id="modalClose"
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-submit"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {error &&
        <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert>
      }

      {isInvoiceSubmitted &&
        <Alert severity="success" sx={{ mb: 1 }}>
          This invoice has already been submitted and cannot be updated.
        </Alert>
      }

      {pageLoading ? (
        <div id="global-loader" className="page-loader">
          <div className="whirly-loader"></div>
        </div>
      ) : (
        <form onSubmit={handleSubmit(submitForm)}>
          <div className="card">
            <div className="card-body add-product pb-0" style={{ padding: '1rem' }}>
              <div className="row">
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="mb-1 add-product">
                    <SelectField
                      disabled={isInvoiceSubmitted}
                      label={"Invoice Type*"}
                      placeholder={"Invoice Type"}
                      options={invoiceTypes}
                      selected={selectedInvoiceType}
                      onSelect={(value) => setSelectedInvoiceType(value)}
                      error={errors?.invoiceType?.message}
                      register={register("invoiceType", {
                        required: 'Please select invoice type.'
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="mb-1 add-product">
                    <div className="input-blocks mb-0">
                      <label>Invoice Date*</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <Controller
                          name="invoiceDate"
                          control={control}
                          rules={{ required: 'Please enter invoice date.' }}
                          render={({ field: { onChange, onBlur, value, ref } }) => (
                            <>
                              <DatePicker
                                disabled={isInvoiceSubmitted}
                                className="datetimepicker"
                                placeholder="Invoice Date"
                                format={DateFormate}
                                onChange={(date) => onChange(date || null)}
                                status={errors?.invoiceDate?.message && "error"}
                                onBlur={onBlur}
                                value={value ? dayjs(value, DateFormate) : null}
                                ref={ref}
                              />
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-2"></div>
              <div className="row justify-content-between">
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-lg-6 col-sm-6 col-12">
                        <div className="mb-1 add-product">
                          <InputField
                            disabled={isInvoiceSubmitted}
                            label="Invoice Ref No*"
                            placeholder="Invoice Ref No"
                            type="text"
                            size="small"
                            error={errors?.invoiceRefNo?.message}
                            register={register("invoiceRefNo", {
                              required: 'Please enter invoice ref no.',
                              ...noDoubleQuotes()
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6 col-12">
                        <div className="mb-1 add-product">
                          <InputField
                            disabled={isInvoiceSubmitted}
                            label="Seller Business Name*"
                            placeholder="Seller Business Name"
                            type="text"
                            size="small"
                            error={errors?.sellerBusinessName?.message}
                            register={register("sellerBusinessName", {
                              required: 'Please enter seller business name.',
                              ...noDoubleQuotes()
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6 col-12">
                        <div className="mb-1 add-product">
                          <InputField
                            disabled={isInvoiceSubmitted}
                            label="Seller NTN/CNIC*"
                            placeholder="Seller NTN/CNIC"
                            type="text"
                            size="small"
                            error={errors?.sellerNtnCnic?.message}
                            register={register("sellerNtnCnic", {
                              required: 'Please enter seller ntn/cnic.',
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6 col-12">
                        <div className="mb-1 add-product">
                          <InputField
                            disabled={isInvoiceSubmitted}
                            label="Seller STRN"
                            placeholder="Seller STRN"
                            type="text"
                            size="small"
                            register={register("sellerStrn")}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6 col-12">
                        <div className="mb-1 add-product">
                          <InputField
                            disabled={isInvoiceSubmitted}
                            label="Seller Province*"
                            placeholder="Seller Province"
                            type="text"
                            size="small"
                            error={errors?.sellerProvince?.message}
                            register={register("sellerProvince", {
                              required: 'Please enter seller province.',
                              ...noDoubleQuotes()
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6 col-12">
                        <div className="mb-1 add-product">
                          <InputField
                            disabled={isInvoiceSubmitted}
                            label="Seller Address*"
                            placeholder="Seller Address"
                            type="text"
                            size="small"
                            error={errors?.sellerAddress?.message}
                            register={register("sellerAddress", {
                              required: 'Please enter seller address.',
                              ...noDoubleQuotes()
                            })}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-lg-6 col-sm-6 col-12">
                        <div className="mb-1 add-product">
                          <InputField
                            disabled={isInvoiceSubmitted}
                            label="Buyer Business Name*"
                            placeholder="Buyer Business Name"
                            type="text"
                            size="small"
                            error={errors?.buyerBusinessName?.message}
                            register={register("buyerBusinessName", {
                              required: 'Please enter buyer business name.',
                              ...noDoubleQuotes()
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6 col-12">
                        <div className="mb-1 add-product">
                          <InputField
                            disabled={isInvoiceSubmitted}
                            label="Buyer NTN/CNIC*"
                            placeholder="Buyer NTN/CNIC"
                            type="text"
                            size="small"
                            error={errors?.buyerNtnCnic?.message}
                            register={register("buyerNtnCnic", {
                              required: selectedRegistrationType?.id === "Registered" && 'Please enter buyer ntn/cnic.',
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6 col-12">
                        <div className="mb-1 add-product">
                          <InputField
                            disabled={isInvoiceSubmitted}
                            label="Buyer STRN"
                            placeholder="Buyer STRN"
                            type="text"
                            size="small"
                            register={register("buyerStrn")}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6 col-12">
                        <div className="mb-1 add-product">
                          <InputField
                            disabled={isInvoiceSubmitted}
                            label="Buyer Province*"
                            placeholder="Buyer Province"
                            type="text"
                            size="small"
                            error={errors?.buyerProvince?.message}
                            register={register("buyerProvince", {
                              required: 'Please enter buyer province.',
                              ...noDoubleQuotes()
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6 col-12">
                        <div className="mb-1 add-product">
                          <InputField
                            disabled={isInvoiceSubmitted}
                            label="Buyer Address*"
                            placeholder="Buyer Address"
                            type="text"
                            size="small"
                            error={errors?.buyerAddress?.message}
                            register={register("buyerAddress", {
                              required: 'Please enter buyer address.',
                              ...noDoubleQuotes()
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6 col-12">
                        <div className="mb-1 add-product">
                          <SelectField
                            disabled={isInvoiceSubmitted}
                            label={"Buyer Registration Type*"}
                            placeholder={"Buyer Registration Type"}
                            options={registrationTypes}
                            selected={selectedRegistrationType}
                            onSelect={(value) => setSelectedRegistrationType(value)}
                            error={errors?.registrationType?.message}
                            register={register("registrationType", {
                              required: 'Please select registration type.'
                            })}
                          />
                        </div>
                      </div>
                      {userData?.environment === 'SANDBOX' &&
                        <div className="col-lg-6 col-sm-6 col-12">
                          <div className="mb-1 add-product">
                            <InputField
                              disabled={isInvoiceSubmitted}
                              label="Scenario Id*"
                              placeholder="Scenario Id"
                              type="text"
                              size="small"
                              error={errors?.scenarioId?.message}
                              register={register("scenarioId", {
                                required: 'Please enter scenario id.',
                              })}
                            />
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                {selectedInvoiceType?.name === "Debit Note" &&
                  <div className="col-lg-6 col-sm-6 col-12">
                    <div className="mb-1 add-product">
                      <InputField
                        disabled={isInvoiceSubmitted}
                        label="Reason*"
                        placeholder="Reason"
                        type="text"
                        size="small"
                        error={errors?.reason?.message}
                        register={register("reason", {
                          required: selectedInvoiceType?.name === "Debit Note" && 'Please enter reason.',
                          ...noDoubleQuotes()
                        })}
                      />
                    </div>
                  </div>
                }
              </div>
              <div className="mb-2">
                <div className="addproduct-icon" style={{ paddingBottom: '10px', marginBottom: '10px' }}>
                </div>
                {!isInvoiceSubmitted &&
                  <div className="row">
                    <div className="col-lg-3 col-sm-3 col-6 my-2">
                      <button type="button"
                        className="btn btn-info"
                        data-bs-toggle="modal"
                        data-bs-target="#open-product-modal"
                        onClick={() => resetAddRowFields()}
                      >
                        Add Product
                      </button>
                    </div>
                  </div>
                }
                <div className="table-responsive">
                  <table className="table">
                    <thead className="table-primary thead-light">
                      {renderTableHeader()}
                    </thead>
                    <tbody>
                      {products?.length > 0 ? (
                        <>
                          {renderTableBody()}
                        </>
                      ) : (
                        <tr>
                          <td colSpan={19}>No Product Found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              {isInvoiceSubmitted ? (
                <button type="button" className="btn btn-cancel me-2" onClick={() => navigate(routes?.invoices)}>
                  Back
                </button>
              ) : (
                <>
                  <button type="button" className="btn btn-cancel me-2" onClick={() => navigate(-1)}>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-submit"
                    disabled={loading}
                  >
                    Save
                  </button>
                </>
              )}
            </div>
          </div>
        </form>
      )}
    </>
  );
};